<template>
    <div class="banner-conheca banner wow animate__animated animate__fadeInRightBig">
        <h1 class="text-center">Conheça o Fresto</h1>
    </div>
    <div class="container py-5">        
        <div class="row mb-5 wow animate__animated animate__fadeInLeftBig">
            <div class="col-sm-12 col-md-6 col-lg-6">
                <h2 class="txt-green h1-x">
                    <span>Nossa História</span>
                </h2>

                <h3 class="txt-dark-green">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</h3>

                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>

                <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <img src="../assets/img/foto-historia.webp" class="w-100 rounded-5" alt="">
            </div>
        </div>
        <div class="row wow animate__animated animate__fadeInRightBig">
            <div class="col-sm-12 col-md-6 col-lg-6 order-last order-md-first">
                <img src="../assets/img/foto-cozinha.webp" class="w-100 rounded-5" alt="">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 order-first order-md-last">
                <h2 class="txt-green h1-x"><span>Nossa Cozinha</span></h2>

                <h3 class="txt-dark-green">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</h3>

                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>

                <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConhecaFresto'
};
</script>